import React, { useState, useEffect } from 'react';
import logo from '../assets/logo1.png';

function Header() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
                scrolled ? 'bg-black/90 backdrop-blur-md border-b border-white/5' : ''
            }`}
        >
            <div className="px-6 mx-auto max-w-7xl">
                <div className="flex items-center justify-between h-16">
                    <a href="/" className="flex items-center gap-2.5">
                        <img src={logo} width={32} height={32} className="rounded-lg" alt="Unit 326" />
                        <span className="text-white text-sm font-medium tracking-wide">Unit 326</span>
                    </a>

                    <nav className="flex items-center gap-8">

                        <a
                            href="mailto:hello@unit326.com"
                            className="text-black bg-green-400 hover:bg-green-300 text-sm font-medium px-4 py-1.5 rounded-full transition-colors duration-200 no-underline"
                        >
                            Contact
                        </a>
                    </nav>
                </div>
            </div>
        </header>
    );
}

export default Header;
